const mapModals = () => {
  const buttons = document.querySelectorAll(".js-location-button");
  if (buttons.length == 0) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener("mouseleave", () => {
      if (window.innerWidth > 1280) {
        button.classList.remove("active");
      }
    });
    button.addEventListener("mouseenter", () => {
      if (window.innerWidth > 1280) {
        button.classList.add("active");
        buttons.forEach((btn) => {
          if (btn != button) {
            btn.classList.remove("active");
          }
        });
      }
    });

    button.addEventListener("click", () => {
      buttons.forEach((btn) => {
        if (btn != button) {
          btn.classList.remove("active");
        }
      });
      button.classList.toggle("active");
    });
  });
};

export default mapModals;
